import { VIRTUAL_TSS_METADATA } from '@app/modules/tss/config/tss.config';
import {
	TssAssignmentTypeEnum,
	TssVariant
}                               from '@app/modules/tss/models/tss.model';
import { EntityVariantEnum }    from '@models/entity.model';

export const findTssHelperFnForBp = ( tssItem: TssVariant, entityVariant?: EntityVariantEnum ) => {
	const assignmentTypeCheckIsValid: boolean = 'assignmentType' in tssItem
																							? tssItem.assignmentType === TssAssignmentTypeEnum.BUSINESS_PREMISES
																							: true;

	const matchesEntityVariant: boolean = entityVariant
																				? tssItem.entityVariant === entityVariant
																				: true;

	return tssItem
				 && assignmentTypeCheckIsValid
				 && matchesEntityVariant
				 && VIRTUAL_TSS_METADATA.statusAllowedToListTssUnderBusinessPremises( tssItem.entityVariant )?.includes( tssItem.status );
};

export const findTssHelperFnForErs = ( tssItem: TssVariant, entityVariant: EntityVariantEnum ) => {
	const matchesEntityVariant: boolean = tssItem.entityVariant === entityVariant;

	return tssItem
				 && matchesEntityVariant
				 && VIRTUAL_TSS_METADATA.statusAllowedToListTssUnderBusinessPremises( tssItem.entityVariant )?.includes( tssItem.status )
				 ? tssItem
				 : null;
};
